define([
    "./monitoringTripOverviewModule",
    "./monitoringTripOverviewController"
], function () {
});